import controller from './kform-tab-history.controller';
import template from './kform-tab-history.html';
import './kform-tab-history.scss';

export default {
	bindings:  {
		data: '<',
		kid:  '<',
	},
	template,
	controller,
};
